import { Input } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

type Props = {
  value: string;
  setValue: (value: string) => void;
};

const { TextArea } = Input;

/**
 * TextareaField is a component that allows the user to input a string.
 * Normally a normal input would be displayed. This can be used when a formated string is needed.
 *
 * @param {string} value - The current value of the string.
 * @param {function} setValue - A function to set the value of the string.
 */
export default observer((props: Props) => {
  const [state, setState] = useState<string>(props.value);

  useEffect(() => {
    if (props.setValue) {
      props.setValue(state);
    }
  }, [state]);

  return props.setValue ? (
    <TextArea
      rows={4}
      onChange={(event) => setState(event.target.value)}
      value={state}
    />
  ) : (
    <span>{props.value}</span>
  );
});
